import { CSSProperties, FunctionComponent, ReactElement } from 'react';
import { Tooltip, Typography } from '@tempmee/react';
import { colors } from '@tempmee/tailwind';

interface IProps {
  Anchor: ReactElement;
  style?: Partial<{ container: CSSProperties }>;
}

export const ProfessionalBestInDentalWinnerTooltip: FunctionComponent<IProps> = ({
  Anchor,
  style,
}) => {
  return (
    <Tooltip
      title={
        <Typography as="span" bold color={colors.shades[0]}>
          This professional has earned GoTu’s Best in
          <br />
          Dental badge, our highest recognition for
          <br />
          reliability, professionalism, and excellence in
          <br />
          patient care.
        </Typography>
      }
      placement="bottom"
    >
      {Anchor}
    </Tooltip>
  );
};
